import type { FormatterMap, ProductRoutesOptions, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import {
  createAuthFormatters,
  createCheckoutFormatters,
  createMyAccountFormatters,
  productDetailFormatters,
  productListFormatter,
} from '@grandvisionhq/www-next/formatters'

const productRoutesOptions: ProductRoutesOptions = {
  accessories: 'accessorios',
  'contact-lenses': 'lentes-de-contacto',
  frames: 'armacoes-para-oculos-graduados',
  'ready-readers': 'armacoes-para-oculos-graduados/pre-graduados',
  solutions: 'lentes-de-contacto/liquidos-e-gotas-oftalmicas',
  sunglasses: 'oculos-de-sol',
}

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),
  'auth.login': createSimpleFormatter('my-account/login'),
  'auth.callback': createSimpleFormatter('my-account/callback'),
  'auth.reset': createSimpleFormatter('my-account/reset'),
  'auth.activate': createSimpleFormatter('my-account/activate'),
  'auth.logout': createSimpleFormatter('my-account/logout'),
  'auth.logged-out': createSimpleFormatter('my-account/logged-out'),
  'cart.overview': createSimpleFormatter('cart'),
  'appointments.book': createSimpleFormatter('marcar-consulta-visual-gratuita'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  ...createMyAccountFormatters(),
  'express.checkout.login': createSimpleFormatter('express-user-checkout'),
  ...createAuthFormatters(),
  'express-checkout': createSimpleFormatter('express-checkout'),
  'order.confirm': createSimpleFormatter('order/confirm'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: { login: 'login', shipping: 'envio', overview: 'resumen', payment: 'pago' },
  }),
  ...productListFormatter(productRoutesOptions),
  ...productDetailFormatters(productRoutesOptions),
  wishlist: createSimpleFormatter('/wishlist'),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout/login', 'checkout.login'],
  ['/checkout/envio', 'checkout.shipping'],
  ['/checkout/resumo', 'checkout.overview'],
  ['/checkout/pago', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/marcar-consulta-visual-gratuita{/*path}', 'appointments.book'],
  ['/cancelar-marcacao-de-consulta', 'appointments.cancel'],
  ['/reagendar-marcacao-de-consulta', 'appointments.reschedule'],
]
